import { Input } from '@/components/ui';
import { QuestionWrapper } from './question-wrapper';
import type { QuestionComponentProps } from '@/types';

export function OpenNumeric({
  question,
  value,
  onChange,
  disabled,
  errors,
}: QuestionComponentProps<number | null>) {
  const placeholder = question.config?.placeholder || 'Enter a number...';
  const minValue = question.config?.minNumericValue;
  const maxValue = question.config?.maxNumericValue;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;

    if (inputValue === '') {
      onChange(null);
      return;
    }

    const numValue = parseFloat(inputValue);
    if (!isNaN(numValue)) {
      onChange(numValue);
    }
  };

  return (
    <QuestionWrapper question={question} errors={errors}>
      <Input
        type="number"
        value={value ?? ''}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={disabled}
        hasError={!!errors?.length}
        min={minValue}
        max={maxValue}
        step="any"
        className="max-w-xs"
      />

      {/* Range hint */}
      {(minValue !== undefined || maxValue !== undefined) && (
        <p className="mt-1 text-xs text-gray-500">
          {minValue !== undefined && maxValue !== undefined
            ? `Enter a number between ${minValue} and ${maxValue}`
            : minValue !== undefined
            ? `Minimum: ${minValue}`
            : `Maximum: ${maxValue}`}
        </p>
      )}
    </QuestionWrapper>
  );
}
